import { Education } from "../../types/types";

export const Educations: Education[] = [
    {
        title: "Courses in UX Design",
        school: "The Interaction Design Foundation",
        date: "2021 - now",
    },
    {
        title: "Frontend Developer",
        school: "Medieinstitutet",
        date: "dec 2020 - sep 2022",
    },
    {
        title: "Courses in Sociology, Psychology and Organization",
        school: "Stockholm University",
        date: "aug 2019 - dec 2020",
    },
    {
        title: "High School Diploma, Information and Media Technology",
        school: "Luleå Gymnasieskola",
        date: "aug 2013 - jun 2016",
    },
];
